import { useInputMethodContext } from '../contexts/InputMethodContext/InputMethodContext';

const isTouchEnabled = () => {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
};

export const useHoverStylesClassName = () => {
  const { inputMethod } = useInputMethodContext();
  const isInputMethodMouse = inputMethod === 'mouse';

  return isInputMethodMouse && !isTouchEnabled()
    ? 'hover-styles-enabled'
    : undefined;
};
